<style>
.notifications-btn {
  border-radius: 999px !important;
  max-height: 40px;
  min-height: 40px;
  max-width: 40px;
  min-width: 40px;
  box-shadow: rgb(102, 102, 102) 0px 2px 8px;
}

.active-pulse {
  box-shadow: #a94442 0px 2px 8px;
  -webkit-animation-name: pulse; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 4s; /* Safari 4.0 - 8.0 */
  animation-name: pulse;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0% { box-shadow: #a94442 0px 2px 8px; }
  50% { box-shadow: #a94442 0px 4px 16px; }
}
</style>

<template>
  <span>
    <b-button
      class="notifications-btn"
      :class="{ 'active-pulse': shouldPulse }"
      variant="dark"
      :id="btnId"
      @click="toggleNotifications"
    >
      <font-awesome-icon icon="bell" />
      <span class="sr-only">Notifications</span>
    </b-button>
    <notifications-popover
      ref="nPopover"
      placement="right"
      :target="btnId"
      @item-clicked="itemClicked"
    />
    <notification-modal
      ref="nModal"
      :item="selected"
      @hidden="clearNotification"
    />
  </span>
</template>


<script>
import { MARK_NOTIFICATION_READ } from '@/vuex/modules/notifications/types/actions';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import NotificationModal from './NotificationModal';
import NotificationsPopover from './NotificationsPopover';


library.add([faBell]);

export default {
  components: {
    NotificationModal,
    NotificationsPopover,
  },
  data: () => ({
    btnId: 'notifications-btn-id',
    selected: {},
    mounted: false,
  }),
  computed: {
    hasItems() {
      return this.$store.getters.notifications.length !== 0;
    },
    shouldPulse() {
      if (!this.mounted) { return this.hasItems; }

      const popover = this.$refs.nPopover;
      return this.hasItems && !popover.display;
    },
  },
  methods: {
    toggleNotifications() {
      this.$refs.nPopover.toggleDisplay();
    },
    itemClicked(item) {
      this.selected = item;
      this.$refs.nModal.show();
    },
    clearNotification() {
      const notificationID = this.selected.id;
      this.selected = {};
      this.$reqs.post(
        `/users/${this.$store.getters.user.id}/notifications/${notificationID}/mark_read`,
        null,
        { pre: false, post: false, error: false },
      );

      this.$store.dispatch(MARK_NOTIFICATION_READ, { id: notificationID });
    },
  },
  mounted() {
    this.mounted = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/profile/notifications/NotificationsButton.vue